import React, { useState, useEffect } from 'react';

import { Container as MuiContainer } from '@sunwisesoftware/sunwise-ui';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';

import * as createTemplateModalActions from '../createTemplateModal/actions';
import * as createTemplateModalSelectors from '../createTemplateModal/selectors';

import * as actions from './actions';
import ListItems from './components/ListItems';
import * as selectors from './selectors';

const Container = ({
    fetchSystemTypes,
    filterTemplates,
    handleClickBulkItems,
    handleClickDuplicate,
    handleClickEdit,
    handleSaveRow,
    handleUpdateFilterData,
    isFetching,
    paginationData,
    systemTypes,
    templates,
}) => {
    const [filterData, setFilterData] = useState({
        orderBy: 'created_at',
        page: 0,
        pageSize: 25,
        searchText: '',
        sortBy: 'desc',
        status: 'active',
    });

    useEffect(() => {
        fetchSystemTypes();
        filterTemplates(filterData);
    }, []);

    return (
        <MuiContainer maxWidth="false">
            <ListItems
                filterData={filterData}
                filterItems={filterTemplates}
                handleClickBulkItems={handleClickBulkItems}
                handleClickDuplicate={handleClickDuplicate}
                handleClickEdit={handleClickEdit}
                handleSaveRow={handleSaveRow}
                handleUpdateFilterData={handleUpdateFilterData}
                isFetching={isFetching}
                items={templates}
                paginationData={paginationData}
                setFilterData={setFilterData}
                systemTypes={systemTypes}
            />
        </MuiContainer>
    );
};

Container.propTypes = {
    fetchSystemTypes: PropTypes.func,
    filterTemplates: PropTypes.func,
    handleClickBulkItems: PropTypes.func,
    handleClickDuplicate: PropTypes.func,
    handleClickEdit: PropTypes.func,
    handleSaveRow: PropTypes.func,
    handleUpdateFilterData: PropTypes.func,
    isFetching: PropTypes.bool,
    paginationData: PropTypes.object,
    systemTypes: PropTypes.array,
    templates: PropTypes.array,
};

const mapStateToProps = createStructuredSelector({
    isDuplicating: selectors.getIsDuplicatingTemplate,
    isFetching: selectors.getIsFetchingTemplates,
    isFetchingBulk: selectors.getIsFetchingBulk,
    isSaving: selectors.getIsSaving,
    paginationData: selectors.getTemplatesPagination,
    systemTypes: createTemplateModalSelectors.getSystemTypesData,
    templates: selectors.getTemplatesData,
});

const mapDispatchToProps = (dispatch) => ({
    fetchSystemTypes: () =>
        dispatch(createTemplateModalActions.fetchSystemTypes()),
    filterTemplates: (filterData) =>
        dispatch(actions.filterTemplates(filterData)),
    handleClickBulkItems: (ids, value, filterData, callback) =>
        dispatch(actions.prepareBulkItems(ids, value, filterData, callback)),
    handleClickDuplicate: (filterData, values) =>
        dispatch(actions.duplicateTemplate(filterData, values)),
    handleClickEdit: (values) =>
        dispatch(createTemplateModalActions.prepareUpdate(values)),
    handleSaveRow: (filterData, values) =>
        dispatch(actions.updateTemplate(filterData, values)),
    handleUpdateFilterData: (values) => dispatch(actions.setFilterData(values)),
});

export default connect(mapStateToProps, mapDispatchToProps)(Container);
